import { Box } from "@mui/material";
import { BsFileEarmarkSpreadsheet } from "react-icons/bs";
import { HeaderOptions } from "../../../../types/budget/budget";

type Props = {
  type: HeaderOptions;
  isActive: boolean;
  setIsActive: (type: HeaderOptions) => void;
  description?: string;
};

export default function CalcOption({
  type,
  isActive,
  setIsActive,
  description,
}: Props) {
  return description ? (
    <Box
      borderRadius={1}
      m={0.25}
      display={"flex"}
      fontSize={"16px"}
      fontWeight={"bold"}
      flexDirection={"row"}
      alignItems={"center"}
      p={"14px 8px"}
      sx={{ minWidth: 0 }}
      style={
        isActive
          ? { background: "#1976D2", color: "white", cursor: "pointer" }
          : { background: "#f3f3f3", color: "#222", cursor: "pointer" }
      }
      onClick={() => setIsActive(type)}
    >
      {type === "budgetTotals" ? (
        <BsFileEarmarkSpreadsheet style={{ strokeWidth: 0.7 }} />
      ) : (
        type
      )}
      <Box
        sx={{
          backgroundColor: isActive ? "#ffffff1e" : "#5555551b",
          width: "1px",
          alignSelf: "stretch",
          margin: 1,
        }}
      />
      <Box
        fontWeight={"400"}
        fontSize={"14px"}
        sx={{
          minWidth: 0,
          overflowWrap: "break-word",
          wordBreak: "break-word",
        }}
      >
        {description}
      </Box>
    </Box>
  ) : (
    <Box
      width={"40px"}
      height={"40px"}
      borderRadius={1}
      m={0.25}
      display={"flex"}
      fontSize={"16px"}
      fontWeight={"bold"}
      flexDirection={"row"}
      alignItems={"center"}
      justifyContent={"center"}
      style={
        isActive
          ? { background: "#1976D2", color: "white", cursor: "pointer" }
          : { background: "#f3f3f3", color: "#222", cursor: "pointer" }
      }
      onClick={() => setIsActive(type)}
    >
      {type === "budgetTotals" ? (
        <BsFileEarmarkSpreadsheet style={{ strokeWidth: 0.7 }} />
      ) : (
        type
      )}
    </Box>
  );
}
